import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import VerticalContext from '../VerticalContext';

/**
 * `SectionItem` component is used for showing parameters and its values in [Section](#!/Section).
 * @since 0.0.54
 */
var SectionItem = function SectionItem(_ref) {
  var _classNames;

  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children,
      title = _ref.title,
      actions = _ref.actions,
      vertical = _ref.vertical,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "children", "title", "actions", "vertical"]);

  var verticalContext = useContext(VerticalContext);
  return React.createElement("div", _extends({
    className: classNames(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--actions"), actions), _defineProperty(_classNames, "".concat(baseClassName, "--vertical"), vertical === undefined ? verticalContext : vertical), _classNames), className)
  }, props), title === undefined || title === null ? null : React.createElement("div", {
    className: "".concat(baseClassName, "__title")
  }, title), React.createElement("div", {
    className: "".concat(baseClassName, "__value")
  }, children));
};

SectionItem.propTypes = {
  /**
   * Content of the `SectionItem`.
   * @since 0.0.54
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string,

  /**
   * Title of the section item.
   * @since 0.0.54
   */
  title: PropTypes.node,

  /**
   * Is this section item contains actions? If it so than there should be extra whitespaces.
   * @since 0.0.54
   */
  actions: PropTypes.bool,

  /**
   * @ignore
   */
  vertical: PropTypes.bool
};
SectionItem.defaultProps = {
  children: undefined,
  className: undefined,
  baseClassName: "".concat(CLS_PREFIX, "section-item"),
  title: undefined,
  actions: false,
  vertical: undefined
};
export default SectionItem;